import { KmsTypeFilterItemCheckbox } from "@kaltura/mediaspace-shared-types";
import { Checkbox, MenuItem } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";
import { MenuItemProps } from "../types";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    marginRight: theme.spacing(1),
}));

const MultiSelectionMenuItem = (props: MenuItemProps) => {
    const { option, isChecked, onChange, autoFocus, disabled = false } = props;

    return (
        <MenuItem
            role="menuitemcheckbox"
            aria-checked={isChecked(option.value)}
            onClick={() => onChange(option as KmsTypeFilterItemCheckbox)}
            autoFocus={autoFocus}
            disabled={disabled}
        >
            <StyledCheckbox
                checked={isChecked(option.value)}
                onClick={() => onChange(option as KmsTypeFilterItemCheckbox)}
            />
            <span className="kms-ds-channels-filter-menu-item-label">{option.label}</span>
        </MenuItem>
    );
};

export default MultiSelectionMenuItem;
